// GALILEO-2516 START
import React from 'react';
import Image3 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/jpd-prioritization-delivery/index.tsx';
import Image1 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/jpd-prioritization-idea/index.tsx';
import Image2 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/jpd-prioritization-roadmap/index.tsx';
import type { TemplateStaticContent } from '../../../../common/types.tsx';
import commonJPDMessages from '../messages.tsx';
import messages from './messages.tsx';

export const TEMPLATE_KEY = 'jpd.prioritization' as const;

export const prioritizationProductDiscoveryProject: TemplateStaticContent = {
	key: TEMPLATE_KEY,
	overviewContent: {
		valueProps: [
			{
				title: messages.valueProp1Title,
				description: messages.valueProp1Description,
				imageComponent: () => <Image1 alt="" />,
				imageUrl: '',
			},
			{
				title: messages.valueProp2Title,
				description: messages.valueProp2Description,
				imageUrl: '',
				imageComponent: () => <Image2 alt="" />,
			},
			{
				title: messages.valueProp3Title,
				description: messages.valueProp3Description,
				imageUrl: '',
				imageComponent: () => <Image3 alt="" />,
			},
		],
		recommendedList: [messages.recommendedList1],
		workType: 'Issue',
		issueTypes: [{ key: 'idea', label: commonJPDMessages.idea }],
		workflow: [
			{ label: commonJPDMessages.parkingLot, appearance: 'default' },
			{ label: commonJPDMessages.discovery, appearance: 'inprogress' },
			{ label: commonJPDMessages.readyForDelivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.delivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.impact, appearance: 'inprogress' },
			{ label: commonJPDMessages.archived, appearance: 'success' },
		],
	},
};
// GALILEO-2516 END
